import { useTranslator } from "@eo-locale/react";

import { Button, Stack } from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";

const MobilePinActions = ({
  handleCancelPinMobile,
  handleConfirmPinMobile
}) => {
  const { translate } = useTranslator();

  const { isEditMode } = useAppSelector((state) => state.placesMarkerSlice);

  return (
    <Stack
      background={"white"}
      w="100%"
      py={6}
      px={4}
      color="black"
      position="fixed"
      bottom={0}
      zIndex="9999"
      direction="row"
      justifyContent="space-between"
      spacing={4}
    >
      <Button variant="secondary" width="full" onClick={handleCancelPinMobile}>
        {translate("common.cancel")}
      </Button>
      <Button variant="primary" width="full" onClick={handleConfirmPinMobile}>
        {isEditMode ? translate("common.update") : translate("common.confirm")}
      </Button>
    </Stack>
  );
};
export default MobilePinActions;
